export const primary = "";
export const winelisthp = "#575555";
export const winetitle = "#847400";
export const winetitleHover = "#ffe000";
export const sectiontitleLighter = "#9e8b01";
export const borderColor = "#b59f00";
export const greyDescription = "#737272";
